import React, { useState } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "How to open an account with HC Finvest?",
    answer:
      "You can open an account by registering on the HC Finvest platform, filling in your basic details, and completing the verification (KYC) process.",
  },
  {
    question: "What are the differences between a demo and a real account?",
    answer:
      "A demo account allows you to trade using virtual funds for practice, while a real account involves actual money and live market conditions.",
  },
  {
    question: "Is there a minimum deposit required to start trading?",
    answer:
      "Yes, a minimum deposit is required to activate a live trading account. The amount depends on the account type you choose.",
  },
  {
    question: "Can I switch from a demo account to a real account?",
    answer:
      "Yes, you can upgrade to a real account anytime by completing verification and making a deposit.",
  },
  {
    question: "Can I have both demo and real accounts at the same time?",
    answer:
      "Yes, you can maintain both accounts simultaneously to practice strategies while trading live.",
  },
  {
    question: "What account types are available at HC Finvest?",
    answer:
      "HC Finvest offers multiple account types designed for different trading needs, including beginner-friendly and advanced trading accounts.",
  },
  {
    question: "Can I open multiple trading accounts?",
    answer:
      "Yes, users can open multiple accounts (if supported) to manage different strategies or trading preferences.",
  },
  {
    question: "Is my trading account secure?",
    answer:
      "Yes, HC Finvest uses advanced security systems and encryption to protect user accounts and transactions.",
  },
  {
    question: "How can I access my trading account?",
    answer:
      "You can access your account through the HC Finvest web platform using your registered login credentials.",
  },
  {
    question: "What should I do if I forget my account password?",
    answer:
      "You can reset your password using the “Forgot Password” option on the login page or contact support for assistance.",
  },
];

const TradingAccountfaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
      <>
        <Helmet>
          <link rel="canonical" href="https://www.hcfinvest.com/tradingAccountfaq" />
        </Helmet>

      <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
        <ScrollToTopButton/>
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/HelpCenterImages/Newhedgecapitalsimage_Helpcenter 1.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h1
          // variant="h3"
          // component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Trading Accounts
        </h1>

        <h3
          // variant="h5"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Choose the Right Account to Match Your Trading Style
        </h3>
      </Box>

      <Typography
        variant="h2"
        sx={{
          marginBottom: "50px",
          fontWeight: "600",
          fontSize: "2.5rem",
          color: "#101828",
        }}
      >
        FAQ
      </Typography>

      <Box sx={{ maxWidth: "1200px", margin: "40px auto" }}>
        {faqs.map((faq, index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleToggle(index)}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {faq.question}
                </Typography>
                <IconButton>
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </IconButton>
              </Box>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 2,
                    color: "text.secondary",
                    lineHeight: 1.7,
                    textAlign: "left",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container> 
      </>
  );
};

export default TradingAccountfaq;
